<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Add an Announcement
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="6">
              <v-text-field
                v-model="form.title"
                outlined
                label="Title *"
                prepend-inner-icon="mdi-bullhorn"
                :error-messages="formErrors.title"
                counter="100"
                maxlength="100"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.message"
                outlined
                label="Subtitle"
                prepend-inner-icon="mdi-subtitles"
                :error-messages="formErrors.message"
                counter="225"
                maxlength="225"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-autocomplete
                v-model="form.audience_type"
                :items="audienceTypes"
                item-text="text"
                item-value="value"
                outlined
                label="Audience Type"
                prepend-inner-icon="mdi-account-group"
                :error-messages="formErrors.audience_type"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col sm="6">
              <v-menu
                v-model="publishDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="publishedAtFormatted"
                    label="Publication Date & Time"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    :error-messages="formErrors.published_at"
                    clearable
                    @click:clear="clearPublishDate"
                  ></v-text-field>
                </template>
                <v-card>
                  <v-card-title class="primary white--text">
                    Select Publication Date & Time
                  </v-card-title>
                  <v-card-text>
                    <v-date-picker
                      v-model="publishDate"
                      no-title
                      scrollable
                    ></v-date-picker>
                    <v-time-picker
                      v-if="publishDate"
                      v-model="publishTime"
                      format="24hr"
                      scrollable
                    ></v-time-picker>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="publishDateMenu = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="setPublishDateTime">
                      OK
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="form.description"
                outlined
                label="Description"
                prepend-inner-icon="mdi-text"
                :error-messages="formErrors.description"
                rows="5"
                counter
              ></v-textarea>
            </v-col>
          </v-row>

          <v-divider class="mt-5 mb-5"></v-divider>
          <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            rounded
            color="primary"
            dark
            @click="save"
          >
            Save Announcement
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "@/axios";
import { combineIstDateTime, APP_TIMEZONE } from "@/utils/dateTime";

export default {
  name: "AnnouncementCreatePage",
  data() {
    return {
      form: {
        title: "",
        message: "",
        description: "",
        audience_type: null,
        published_at: null,
        is_active: true,
      },
      formErrors: {},
      isLoading: false,
      publishDateMenu: false,
      publishDate: null,
      publishTime: null,
      audienceTypes: [
        { text: "All Users", value: "all_users" },
        { text: "Doctors", value: "doctors" },
        { text: "Patients", value: "patients" },
      ],
    };
  },
  computed: {
    publishedAtFormatted() {
      if (!this.form.published_at) return null;
      const date = new Date(this.form.published_at);
      return date.toLocaleString("en-IN", { timeZone: APP_TIMEZONE });
    },
  },
  methods: {
    setPublishDateTime() {
      if (this.publishDate) {
        this.form.published_at = combineIstDateTime(this.publishDate, this.publishTime);
      }
      this.publishDateMenu = false;
    },

    clearPublishDate() {
      this.form.published_at = null;
      this.publishDate = null;
      this.publishTime = null;
    },

    async save() {
      try {
        this.isLoading = true;
        this.formErrors = {};

        const response = await axios.post("/announcements", this.form);

        if (response.data.success) {
          this.$store.dispatch("errors/setSuccess", {
            message: "Announcement created successfully",
          });
          this.$router.push("/announcements");
        } else {
          this.$store.dispatch("errors/setError", {
            message: response.data.message || "Failed to create announcement",
          });
        }
      } catch (error) {
        console.error("Error creating announcement:", error);
        
        if (error.response && error.response.status === 422) {
          this.formErrors = error.response.data.errors || {};
        } else if (error.response && error.response.status === 401) {
          this.$router.push("/login");
        } else {
          this.$store.dispatch("errors/setError", {
            message: "Error creating announcement",
          });
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>